// extracted by mini-css-extract-plugin
module.exports = {"calendarTipContainer":"style_calendarTipContainer__7_utb"};